export default __webpack_public_path__ + "static/cnvb-f43d600ee28dc94306c14b59d4049cd2.svg";